import { render, staticRenderFns } from "./GeneBrowser.vue?vue&type=template&id=778d6150&scoped=true"
import script from "./GeneBrowser.vue?vue&type=script&lang=js"
export * from "./GeneBrowser.vue?vue&type=script&lang=js"
import style0 from "./GeneBrowser.vue?vue&type=style&index=0&id=778d6150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778d6150",
  null
  
)

export default component.exports